module.exports = __webpack_public_path__ + "img/salsa_1390.43b8c547.jpg";